import { render, staticRenderFns } from "./ReviewYoutubeVideo.vue?vue&type=template&id=e1e3b648&scoped=true"
import script from "./ReviewYoutubeVideo.vue?vue&type=script&lang=js"
export * from "./ReviewYoutubeVideo.vue?vue&type=script&lang=js"
import style0 from "./ReviewYoutubeVideo.vue?vue&type=style&index=0&id=e1e3b648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e3b648",
  null
  
)

export default component.exports